import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/domains';
import { EssayDraftAnswer } from '../../../core';
export var ESSAY_ANSWER_DRAFT_WEB_CACHED = 'ESSAY_ANSWER_DRAFT_WEB_CACHED';
export var EssayAnswerDraftWebCached = /*#__PURE__*/function () {
  function EssayAnswerDraftWebCached() {
    _classCallCheck(this, EssayAnswerDraftWebCached);
  }

  _createClass(EssayAnswerDraftWebCached, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(essayDraftAnswer) {
        var queryString;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryString = new URLSearchParams({
                  submissionId: essayDraftAnswer.submissionId,
                  questionId: essayDraftAnswer.questionId
                }).toString();
                localStorage.setItem("".concat(ESSAY_ANSWER_DRAFT_WEB_CACHED, "_").concat(queryString), JSON.stringify(essayDraftAnswer.content));
                return _context.abrupt("return", Result.ok(essayDraftAnswer));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var params, cachedData, essayDraftAnswer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = new URLSearchParams(id);
                cachedData = JSON.parse(localStorage.getItem("".concat(ESSAY_ANSWER_DRAFT_WEB_CACHED, "_").concat(id)));
                essayDraftAnswer = EssayDraftAnswer.create({
                  submissionId: params.get('submissionId'),
                  questionId: params.get('questionId'),
                  content: cachedData || null
                }).getValue();
                return _context2.abrupt("return", Result.ok(essayDraftAnswer));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function findById(_x2) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                localStorage.removeItem("".concat(ESSAY_ANSWER_DRAFT_WEB_CACHED, "_").concat(id));
                return _context3.abrupt("return", Result.ok(true));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _delete(_x3) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "deleteMany",
    value: function () {
      var _deleteMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var keyToMatch, i, key;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                keyToMatch = "".concat(ESSAY_ANSWER_DRAFT_WEB_CACHED); // eslint-disable-next-line no-loops/no-loops

                for (i = 0; i < localStorage.length; i++) {
                  key = localStorage.key(i);

                  if (key && key.includes(keyToMatch)) {
                    localStorage.removeItem(key);
                  }
                }

                return _context4.abrupt("return", Result.ok());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function deleteMany() {
        return _deleteMany.apply(this, arguments);
      }

      return deleteMany;
    }()
  }, {
    key: "update",
    value: function update(id, domain) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "count",
    value: function count() {
      throw new Error('Method not implemented.');
    }
  }]);

  return EssayAnswerDraftWebCached;
}();